import { useUserContext } from "../../contexts/userContext";
import { dataProduction } from "../../data/dataProduction";
import { Card } from "../ui/Card";

const SectionCard = () => {
  const { role } = useUserContext();

  const dataProductionFilter = dataProduction.filter((item) => {
    if (role === "Lecteur") {
      return (
        item.id !== 1 &&
        item.id !== 2 &&
        item.id !== 3 &&
        item.id !== 4 &&
        item.id !== 5 &&
        item.id !== 6 &&
        item.id !== 7 &&
        item.id !== 9 && 
        item.id !== 11
      );
    } else if (role === "Editeur") {
      return (
        item.id !== 1 &&
        item.id !== 2 &&
        item.id !== 3 &&
        item.id !== 4 &&
        item.id !== 5 &&
        item.id !== 6 &&
        item.id !== 9 && 
        item.id !== 11
      );
    } else if (role === "Superviseur") {
      return (
        item.id !== 2 &&
        item.id !== 3 &&
        item.id !== 4 &&
        item.id !== 5 &&
        item.id !== 6 &&
        item.id !== 9 
      );
    } else if (role === "Comptabilité") {
      return (
        item.id !== 1 &&
        item.id !== 2 &&
        item.id !== 3 &&
        item.id !== 4 &&
        item.id !== 5 &&
        item.id !== 6 &&
        item.id !== 8 && 
        item.id !== 11
      );
    } else if (role === "Admin") {
      return true;
    } else if (role === "Direction") {
      return true;
    }
    return true;
  });

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {/* Card */}
      {dataProductionFilter?.map((item) => (
        <Card
          key={item.id}
          title={item.title}
          icon={item.icon}
          description={item.description}
          link={item.link}
        />
      ))}
    </div>
  );
};

export default SectionCard;
